<template>
  <div class="segments">
    <a
      href="/"
      :class="{'active-segment': true}"
      @click="setCommercialVehicle(false)"
    >
      <div class="segment-icon auto"></div>
      <span>Személyautó</span>
    </a>
    <a
      href="/hu/haszongepjarmu"
      :class="{'active-segment': false}"
      @click="setCommercialVehicle(true)"
    >
      <div class="segment-icon van"></div>
      <span>Haszongépjármű</span>
    </a>
  </div>
</template>

<script>
  import { Component, Vue } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const settingsModule = namespace('settings');

  @Component
  export default class CarTypeSelector extends Vue {
    @settingsModule.State('commercialVehicle') commercialVehicle;
    @settingsModule.Mutation('setCommercialVehicle') setCommercialVehicle;
    @settingsModule.Action('initializeState') initializeState;

    created() {
      this.initializeState();
    }
  }
</script>

<style scoped>
  .segments a {
    cursor: pointer;
  }
</style>
